<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.import')"
  :rightActions="rightActions"
)
  p
    a(
      href="/finance_rocks_new.csv"
      target="_blank"
    ) {{ $t("companies.file_example") }}
  UiFilePicker(
    v-model="file"
    placeholder="Choose a file or drop it here..."
    :extensions="['csv']"
  )
</template>

<script>
import ApiCompanies from "@/api/companies.js";

export default {
  data() {
    return {
      show: false,
      file: null,
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.upload"),
          icon: "FileUpload",
          disabled: !this.file,
          onClick: this.upload,
        },
      ];
    },
  },

  methods: {
    open() {
      this.show = true;
    },

    close() {
      this.show = false;
    },

    upload() {
      let formData = new FormData();
      formData.append("file", this.file);
      ApiCompanies.importCompanies(formData)
        .then((resp) => {
          this.$emit("done");
          this.close();
        })
        .catch((e) => {});
    },
  },
};
</script>
